// eslint-disable-next-line import/prefer-default-export
export function errorCatcher(error, type) {
  console.log(type, error);
  return {
    type,
    payload: error
  };
}
